// extracted by mini-css-extract-plugin
export default {"label":"label_label__bmTIn","shortLabel":"label_shortLabel__Fm97c","inputLabel":"label_inputLabel__4H7YR","checkboxLabel":"label_checkboxLabel__pHTWe"};